import { queryString } from 'lib/format';

const appLinkBase = 'espnapi://espnnetworks.AdobePassProviderChosen';

export default class Provider {
    constructor({
        id,
        name,
        abbreviation,
        ispId,
        tier = 2,
        rank,
        links,
        images,
        analytics = {},
        streamLimiting = {},
        countries = [{countryCode: 'US'}],
        packages = []
    }, partner = 'espn', platform = 'web', version) {
        this.id = id;
        this.name = name;
        this.abbreviation = abbreviation || ispId;
        this.ispId = ispId;
        this.tier = tier;
        this.rank = rank,
        this.links = links;
        this.images = images;
        this.analytics = analytics;
        this.streamLimiting = streamLimiting;
        this.countries = countries;
        this.packages = packages;
        const appLinkQuery = queryString({ partner, platform, version, mvpd: abbreviation });
        this.appLink = `${appLinkBase}${appLinkQuery}`
    }

    /**
     * Provider
     * @Param {Object} domesticProvider - A domestic provider from /watch/clients/watchespn-web/providers
     */
    static createProviderDomestic(provider, partner, platform, version) {
        return new Provider(provider, partner, platform, version);
    }

    /**
     * Provider
     * @Param {Object} intlProvider - An international affiliate from the intl provider feed
     */
    static createProviderIntl({
        name,
        adobeId,
        analyticsId,
        ispId,
        logos: {
            desktop,
            mobile,
            settop,
            pickerImage,
            negativebgcolorImage,
            positivebgcolorImage
        },
        websiteUrl,
        countries = [],
        packages
    }, countryCode = '') {
        const providerCountry = countries.filter((country) => country.countryCode.toLowerCase() === countryCode.toLowerCase());
        const tier = (providerCountry.length > 0 && providerCountry[0].tier === 1) ? 1 : 2;
        const rank = (providerCountry.length > 0 && providerCountry[0].rank) ? providerCountry[0].rank : null;

        return new Provider({
            id: adobeId,
            name,
            abbreviation: adobeId,
            ispId,
            links: { web: { href: websiteUrl } },
            images: {
                logo: { href: desktop },
                mobile: { href: mobile },
                settop: { href: settop },
                picker: { href: pickerImage },
                whiteBackground: { href: positivebgcolorImage },
                colorWithPositiveBackground: { href: positivebgcolorImage },
                colorWithNegativeBackground: { href: negativebgcolorImage }
            },
            analytics: { id: analyticsId },
            countries,
            tier,
            rank,
            packages
        })
    }
}



// WEBPACK FOOTER //
// ./app/lib/auth/Provider.js